import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=1023d136&scoped=true&"
import script from "./Journal.vue?vue&type=script&lang=ts&"
export * from "./Journal.vue?vue&type=script&lang=ts&"
import style0 from "./Journal.vue?vue&type=style&index=0&id=1023d136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023d136",
  null
  
)

export default component.exports